module.exports = __webpack_public_path__ + "static/media/logo.a5717968.png";